import { Injectable, inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import type { GetClientSubscriptionResponse } from '@fitness-force/models';
import { PlanCategory } from '@fitness-force/enum';

export interface FreezeFormConfig {
  isRecurringSubscription: boolean;
  freezeCanOnlyBillingCycle: boolean;
  freezeV2Flow: boolean;
  isRescheduleMode: boolean;
  isStopMode: boolean;
  isCancelMode: boolean;
  isApproveMode: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FreezeFormService {
  private fb = inject(UntypedFormBuilder);

  buildFreezeForm(config: FreezeFormConfig): UntypedFormGroup {
    const showDatePickers =
      config.isApproveMode ||
      !config.isRecurringSubscription ||
      !config.freezeCanOnlyBillingCycle;
    const showMultiselect =
      !config.isApproveMode &&
      config.isRecurringSubscription &&
      config.freezeCanOnlyBillingCycle;
    const clientCommentsRequired =
      config.freezeV2Flow &&
      !config.isRescheduleMode &&
      !config.isStopMode &&
      !config.isCancelMode &&
      !config.isApproveMode;

    return this.fb.group({
      startdate: new UntypedFormControl(
        '',
        showDatePickers ? Validators.required : null
      ),
      enddate: new UntypedFormControl(
        '',
        showDatePickers ? Validators.required : null
      ),
      stopdate: new UntypedFormControl(
        '',
        config.isStopMode ? Validators.required : null
      ),
      freezeReason: new UntypedFormControl(
        'Other',
        config.isRescheduleMode ? null : [Validators.required]
      ),
      comment: new UntypedFormControl(''),
      clientVisibleComments: new UntypedFormControl(
        '',
        clientCommentsRequired ? [Validators.required] : null
      ),
      internalComments: new UntypedFormControl(''),
      selectedfreezeattempt: new UntypedFormControl(
        '',
        showMultiselect ? Validators.required : null
      ),
      chargeAmounts: this.fb.array([]),
      chargeDiscounts: this.fb.array([]),
    });
  }

  isRecurringSubscription(subscription: GetClientSubscriptionResponse): boolean {
    if (!subscription || !subscription.subscription_category) {
      return false;
    }
    return (
      subscription.subscription_category === PlanCategory.Contract ||
      subscription.subscription_category.toString() ===
        PlanCategory[PlanCategory.Contract] ||
      subscription.subscription_category === PlanCategory.PayAsYouGo ||
      subscription.subscription_category.toString() ===
        PlanCategory[PlanCategory.PayAsYouGo]
    );
  }

  getFormControl(form: UntypedFormGroup, name: string) {
    return form.controls[name] ?? null;
  }

  getFormArray(form: UntypedFormGroup, name: string): UntypedFormArray {
    return form.controls[name] as UntypedFormArray;
  }
}
